import React, { FC } from 'react';
import { SearchOtherExpenseResponse } from '../../redux/api/otherExpenses/otherExpense.model';
import TwExpenseCard from '../TwExpenseCard/TwExpenseCard';
import { TwButton, TwButtonType } from '../TwButtons/TwButtons';
import { Box, Typography } from '@mui/material';

export interface TwExpenseMobileProps {
  otherExpenses: SearchOtherExpenseResponse[];
  onOpenEditOtherExpenseDialog: (id: string) => void;
  onOpenViewOtherExpenseDialog: (id: string) => void;
  onOpenAddOtherExpenseDialog?: () => void;
  onOpenDeleteOtherExpenseDialog: (id: string, expenseName: string, equipmentName?: string) => void;
  isDriverLink?: boolean;
}

const TwExpenseMobile: FC<TwExpenseMobileProps> = ({
  otherExpenses,
  onOpenEditOtherExpenseDialog,
  onOpenViewOtherExpenseDialog,
  onOpenAddOtherExpenseDialog,
  onOpenDeleteOtherExpenseDialog,
  isDriverLink
}): JSX.Element => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
      <TwButton
        key="1"
        type={TwButtonType.secondary}
        label="Add expense"
        sx={{
          textTransform: 'none'
        }}
        action={(): void => {
          onOpenAddOtherExpenseDialog && onOpenAddOtherExpenseDialog();
        }}
      />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '12px',
          maxHeight: '265px',
          overflow: 'auto'
        }}
      >
        {otherExpenses.map((otherExpense) => (
          <TwExpenseCard
            key={otherExpense.id}
            otherExpense={otherExpense}
            onOpenEditOtherExpenseDialog={onOpenEditOtherExpenseDialog}
            onOpenDeleteOtherExpenseDialog={onOpenDeleteOtherExpenseDialog}
            onOpenViewOtherExpenseDialog={onOpenViewOtherExpenseDialog}
            isDriverLink={isDriverLink}
          />
        ))}
      </Box>
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)' }}>
        <Typography variant="body2" sx={{ color: '#9CA3AF', fontWeight: '600' }}>
          TOTAL
        </Typography>
        <Typography variant="body2" sx={{ color: '#111827', fontWeight: '600' }}>
          {`$${otherExpenses.reduce((acc, curr) => acc + Number(curr.amount), 0)}`}
        </Typography>
      </Box>
    </Box>
  );
};

export default TwExpenseMobile;
